import * as React from 'react';
import { FormGroup } from 'reactstrap';
import { AutoSuggestFilterEditProps } from '../providers/AutoSuggestValue';
import AutoSuggestSingle from 'components/shared/auto-suggest/AutoSuggestSingle';

export const itemToString = (item) => {
	return item ? item.label : '';
};

interface SingleAutoSuggestFilterEdit {
	value: string;
}

/**
 * Configures a single auto suggest value within a filter.
 */
class SingleAutoSuggestFilterEdit extends React.Component<AutoSuggestFilterEditProps> {
	constructor(props) {
		super(props);
	}

	public handleOnChange = (selectedValue: any) => {
		this.props.onChange(selectedValue, false);
	};

	public render() {
		const {
			filter: { options },
			value,
		} = this.props;

		if (!options || !options.baseUrl) {
			return <em>The BaseUrl option has not been set.</em>;
		}

		return (
			<FormGroup>
				<AutoSuggestSingle
					name="AutoSuggestFilter"
					label="Auto Suggest Filter"
					value={value}
					onChange={this.handleOnChange}
					autoSuggestOptions={{
						allowNewValues: false,
						baseUrl: options.baseUrl,
						params: options.params,
					}}
				/>
			</FormGroup>
		);
	}
}

export default SingleAutoSuggestFilterEdit;
